import React from 'react';
import PropTypes from 'prop-types';
import {SortDirectionIcon} from '../../../icons/sort-direction-icon';
import {
	TableRowCalculationsHeader,
	BaseLevelCalculationsHeaderStyle,
	Title,
	Calculation,
	BaseLevelOnlyTextHeaderStyle,
	BaseLevelSpaceHeaderStyle,
	BaseLevelCalculationsHeaderDetailStyle,
} from './style/base_level_calculations_header_style';

// eslint-disable-next-line react/display-name
export const BaseLevelCalculationsHeader = ({
	columns,
	onlyTextItems,
	calculationItems,
	needingSpace,
	stickyTopPosition,
	calculationFlexItems,
	numberOfGroupings,
}) => {
	let index = 0;
	const list = [];

	const getSortDirection = sortBy => {
		return sortBy === 'ascending' ? SortDirectionIcon.DIRECTION.UP : SortDirectionIcon.DIRECTION.DOWN;
	};

	if (onlyTextItems) {
		for (const key of Object.keys(onlyTextItems)) {
			if (columns[key] !== undefined && columns[key] !== 0) {
				list.push(
					<BaseLevelOnlyTextHeaderStyle
						order={columns[key]}
						key={index}
						sortItem={onlyTextItems[key].sortItem ? onlyTextItems[key].sortItem : false}
						isSorting={onlyTextItems[key].isSorting ? onlyTextItems[key].isSorting : null}
					>
						<div>
							<Title onClick={() => onlyTextItems[key].onClickHandler && onlyTextItems[key].onClickHandler(key)}>
								{onlyTextItems[key].text}
							</Title>
							{onlyTextItems[key].isSorting && onlyTextItems[key].isSorting !== null && (
								<SortDirectionIcon
									size={SortDirectionIcon.SIZE.SMALL}
									direction={getSortDirection(onlyTextItems[key].isSorting)}
								/>
							)}
						</div>
					</BaseLevelOnlyTextHeaderStyle>
				);
				index++;
			}
		}
	}

	if (calculationFlexItems) {
		for (const key of Object.keys(calculationFlexItems)) {
			if (columns[key] !== undefined && columns[key] !== 0) {
				list.push(
					<BaseLevelCalculationsHeaderDetailStyle
						order={columns[key]}
						key={index}
						sortItem={calculationFlexItems[key].sortItem ? calculationFlexItems[key].sortItem : false}
						isSorting={calculationFlexItems[key].isSorting ? calculationFlexItems[key].isSorting : null}
					>
						<div>
							<Title
								onClick={() =>
									calculationFlexItems[key].onClickHandler && calculationFlexItems[key].onClickHandler(key)
								}
							>
								{calculationFlexItems[key].text}
							</Title>
							{calculationFlexItems[key].isSorting && calculationFlexItems[key].isSorting !== null && (
								<SortDirectionIcon
									size={SortDirectionIcon.SIZE.SMALL}
									direction={getSortDirection(calculationFlexItems[key].isSorting)}
								/>
							)}
						</div>
					</BaseLevelCalculationsHeaderDetailStyle>
				);
				index++;
			}
		}
	}

	if (calculationItems) {
		for (const key of Object.keys(calculationItems)) {
			if (columns[key] !== undefined && columns[key] !== 0) {
				list.push(
					<BaseLevelCalculationsHeaderStyle
						order={columns[key]}
						key={index}
						sortItem={calculationItems[key].sortItem ? calculationItems[key].sortItem : false}
						isSorting={calculationItems[key].isSorting ? calculationItems[key].isSorting : null}
					>
						<div>
							<Title
								onClick={() =>
									calculationItems[key].onClickHandler && calculationItems[key].onClickHandler(key)
								}
							>
								{calculationItems[key].text}
							</Title>
							{calculationItems[key].isSorting && calculationItems[key].isSorting !== null && (
								<SortDirectionIcon
									size={SortDirectionIcon.SIZE.SMALL}
									direction={getSortDirection(calculationItems[key].isSorting)}
								/>
							)}
						</div>
						<Calculation>{calculationItems[key].total}</Calculation>
					</BaseLevelCalculationsHeaderStyle>
				);
				index++;
			}
		}
	}

	return (
		<TableRowCalculationsHeader stickyTopPosition={stickyTopPosition} numberOfGroupings={numberOfGroupings}>
			{needingSpace === true && <BaseLevelSpaceHeaderStyle />}
			{list}
			{/* 
			{columns.reportedTime !== undefined && columns.reportedTime !== 0 && (
				<BaseLevelCalculationsHeaderStyle order={columns.reportedTime}>
					<Title>Reported</Title>
					<Calculation>{totalReportedTime}</Calculation>
				</BaseLevelCalculationsHeaderStyle>
			)}

			{columns.notes !== undefined && columns.notes !== 0 && (
				<BaseLevelOnlyTextHeaderStyle order={columns.notes}>
					<Title>Notes</Title>
				</BaseLevelOnlyTextHeaderStyle>
			)}
			{columns.date !== undefined && columns.date !== 0 && (
				<BaseLevelOnlyTextHeaderStyle order={columns.date}>
					<Title>Date</Title>
				</BaseLevelOnlyTextHeaderStyle>
			)}
			{columns.personIcon !== undefined && columns.personIcon !== 0 && (
				<BaseLevelOnlyTextHeaderStyle order={columns.personIcon}>
					<Title>Person</Title>
				</BaseLevelOnlyTextHeaderStyle>
			)}

			{columns.roleName !== undefined && columns.roleName !== 0 && (
				<BaseLevelOnlyTextHeaderStyle order={columns.roleName}>
					<Title>Role</Title>
				</BaseLevelOnlyTextHeaderStyle>
			)}

			{columns.departmentName !== undefined && columns.departmentName !== 0 && (
				<BaseLevelOnlyTextHeaderStyle order={columns.departmentName}>
					<Title>Department</Title>
				</BaseLevelOnlyTextHeaderStyle>
			)}

			{columns.clientName !== undefined && columns.clientName !== 0 && (
				<BaseLevelOnlyTextHeaderStyle order={columns.clientName}>
					<Title>Client</Title>
				</BaseLevelOnlyTextHeaderStyle>
			)}

			{columns.task !== undefined && columns.task !== 0 && (
				<BaseLevelOnlyTextHeaderStyle order={columns.task}>
					<Title>Task</Title>
				</BaseLevelOnlyTextHeaderStyle>
			)}

			{columns.project !== undefined && columns.project !== 0 && (
				<BaseLevelCalculationsHeaderDetailStyle order={columns.project}>
					<Title>Project</Title>
				</BaseLevelCalculationsHeaderDetailStyle>
			)}

			{columns.projectName !== undefined && columns.projectName !== 0 && (
				<BaseLevelOnlyTextHeaderStyle order={columns.projectName}>
					<Title>Project</Title>
				</BaseLevelOnlyTextHeaderStyle>
			)}

			{columns.taskName !== undefined && columns.taskName !== 0 && (
				<BaseLevelOnlyTextHeaderStyle order={columns.taskName}>
					<Title>Task</Title>
				</BaseLevelOnlyTextHeaderStyle>
			)}

			{columns.billable !== undefined && columns.billable !== 0 && (
				<BaseLevelOnlyTextHeaderStyle order={columns.billable}>
					<Title>Billable</Title>
				</BaseLevelOnlyTextHeaderStyle>
			)}

			{columns.price !== undefined && columns.price !== 0 && (
				<BaseLevelCalculationsHeaderStyle order={columns.price}>
					<Title>Revenue</Title>
					<Calculation>{totalPrice}</Calculation>
				</BaseLevelCalculationsHeaderStyle>
			)}

			{columns.cost !== undefined && columns.cost !== 0 && (
				<BaseLevelCalculationsHeaderStyle order={columns.cost}>
					<Title>Cost</Title>
					<Calculation>{totalCost}</Calculation>
				</BaseLevelCalculationsHeaderStyle>
			)} */}
		</TableRowCalculationsHeader>
	);
};

BaseLevelCalculationsHeader.propTypes = {
	columns: PropTypes.shape({
		reportedTime: PropTypes.bool,
		personIcon: PropTypes.bool,
		date: PropTypes.bool,
		timeRegType: PropTypes.bool,
		timeRegDetail: PropTypes.bool,
		timeRegId: PropTypes.bool,
		projectName: PropTypes.bool,
		roleName: PropTypes.bool,
		price: PropTypes.bool,
		cost: PropTypes.bool,
		notes: PropTypes.bool,
		taskName: PropTypes.bool,
		needingSpace: PropTypes.bool,
		departmentName: PropTypes.bool,
		billable: PropTypes.bool,
		clientName: PropTypes.bool,
		project: PropTypes.bool,
		task: PropTypes.bool,
	}).isRequired,

	stickyTopPosition: PropTypes.number,
	totalCost: PropTypes.string,
	totalPrice: PropTypes.string,
	totalReportedTime: PropTypes.string,
	needingSpace: PropTypes.bool,
	numberOfGroupings: PropTypes.number,
	onlyTextItems: PropTypes.object,
	calculationItems: PropTypes.object,
	calculationFlexItems: PropTypes.object,
};
